export default __webpack_public_path__ + "static/media/generic-error-icon.c6655fa5.svg";